var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", [_vm._v("Места встройки приложения")]),
      _vm._v(" "),
      _c(
        "b-form",
        { attrs: { inline: "" } },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                label: "Адрес обработчика:",
                "label-for": "input-app-url",
              },
            },
            [
              _c("b-form-input", {
                attrs: {
                  id: "input-app-url",
                  placeholder: "укажите адреc обработчика",
                  type: "url",
                  required: "",
                },
                model: {
                  value: _vm.appUrl,
                  callback: function ($$v) {
                    _vm.appUrl = $$v
                  },
                  expression: "appUrl",
                },
              }),
              _vm._v(" "),
              _c(
                "b-button",
                { attrs: { variant: "primary" }, on: { click: _vm.setAppUrl } },
                [_vm._v("Встроить")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-button",
        {
          attrs: { inline: "", variant: "primary" },
          on: { click: _vm.getPlacements },
        },
        [_vm._v("Получить места встройки")]
      ),
      _vm._v(" "),
      _c(
        "b-button",
        {
          attrs: { inline: "", variant: "danger" },
          on: { click: _vm.deleteAllPlacements },
        },
        [_vm._v("Удалить все места встройки")]
      ),
      _vm._v(" "),
      _c("btable", { attrs: { items: _vm.placement } }),
      _vm._v(" "),
      _c("h3", [_vm._v("Дополнительные свойства Хранилища ")]),
      _vm._v(" "),
      _c("p", [_vm._v("свойства будут добавлены в указанное Хранилище")]),
      _vm._v(" "),
      _c(
        "b-form",
        { attrs: { inline: "" } },
        [
          _c("b-input", {
            staticClass: "mb-2",
            attrs: {
              placeholder: "Укажите хранилище",
              type: "text",
              required: "",
            },
            model: {
              value: _vm.propertiesForEntity,
              callback: function ($$v) {
                _vm.propertiesForEntity = $$v
              },
              expression: "propertiesForEntity",
            },
          }),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "mb-2",
              attrs: { variant: "success" },
              on: {
                click: function ($event) {
                  return _vm.addProperties()
                },
              },
            },
            [_vm._v("Добавить новые свойства")]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "mb-2",
              on: {
                click: function ($event) {
                  _vm.getProperty(_vm.propertiesForEntity)
                },
              },
            },
            [_vm._v("Смотреть дополнительные свойства")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("btable", { attrs: { items: _vm.property } }),
      _vm._v(" "),
      _c("h3", [_vm._v("Хранилища")]),
      _vm._v(" "),
      _c(
        "b-form",
        { attrs: { inline: "" } },
        [
          _c("b-input", {
            staticClass: "mb-2",
            attrs: { type: "text", required: "" },
            model: {
              value: _vm.newEntity,
              callback: function ($$v) {
                _vm.newEntity = $$v
              },
              expression: "newEntity",
            },
          }),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "mb-2",
              on: {
                click: function ($event) {
                  return _vm.addEntity()
                },
              },
            },
            [_vm._v("Добавить хранилище")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("btable", { attrs: { items: _vm.entity, tableType: "entity" } }),
      _vm._v(" "),
      _c(
        "b-button",
        {
          staticClass: "mb-1",
          attrs: { variant: "info", disabled: "" },
          on: { click: _vm.bitrixDelete },
        },
        [_vm._v("Удалить хранилища Битрикса")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }